import router from '../router'
export const offer = {
    state: {
        status: 'init',
        slug: '',
        featuredPackages: [],
        terms: []
    },
    mutations: {
        SET_OFFER_STATUS(state, status) {
            state.status = status
        },
        SET_OFFER_SLUG(state, slug) {
            state.slug = slug
        },
        SET_OFFER_TERMS(state, terms) {
            state.terms = terms
        },
        SET_OFFER_FEATURED_PACKAGES(state, featuredPackages) {
            state.featuredPackages = featuredPackages
        }
    },
    actions: {
        fetchOffer({ commit, getters, dispatch }, slug) {
            commit('SET_OFFER_STATUS', 'pending')
            return dispatch('resetState').then(() => {
                commit('SET_OFFER_SLUG', slug)
                return new Promise((resolve, reject) => {
                    this.$api.get(`b2b/v2/offers/view/${slug}`).then(response => {
                        if(response.status === 200) {
                            for(const [addressIdx, address] of response.data.data.items.entries()) {
                                // fill addresses
                                commit('RESET_CUSTOMER_ADDRESS', addressIdx)
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'city', value: address.city })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'postcode', value: address.postcode })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'street', value: address.address })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                    addressId: addressIdx,
                                    field: 'geometry',
                                    value: {
                                        lat: address.latitude,
                                        lng: address.longitude
                                    }
                                })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', {
                                    addressId: addressIdx,
                                    field: 'warehouse',
                                    value: {
                                        id: address.warehouse_id
                                    }
                                })
                                // TO DO - each address should have own date ranges
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'dateFrom', value: address.date_from })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'dateTo', value: address.date_to })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'clientDetailId', value: address.client_detail_id })
                                commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressIdx, field: 'ids', value: address.ids })
                                // fill cart
                                for(const isodow in address.days) {
                                    for(const packIdx in address.days[isodow]) {
                                        const pack = address.days[isodow][packIdx]
                                        dispatch('applyProductToCart', {
                                            addressId: addressIdx,
                                            amount: pack.amount,
                                            dayInWeek: +pack.isodow - 1,
                                            period: pack.approx_delivery_count,
                                            cycle: pack.cycle,
                                            draggable: false,
                                            net_price: pack.net_price,
                                            product: {
                                                desc_html: pack.desc_html,
                                                id: pack.id,
                                                image_url: pack.image_url,
                                                name: pack.name,
                                                products: pack.products
                                            }
                                        })
                                    }
                                }
                                // set featured offer
                                commit('SET_OFFER_FEATURED_PACKAGES', address.suggestions)
                            }
                            commit('SET_OFFER_STATUS', 'idle')
                            resolve()
                        } else {
                            commit('SET_OFFER_STATUS', 'idle')
                            reject(new Error('API error'))
                        }
                    }).catch(error => {
                        commit('SET_OFFER_STATUS', 'idle')
                        router.push({ name: 'offer-empty' }).catch(() => {})
                        reject(error)
                    })
                })
            })
        },
        setOfferFeaturedPackages({ commit }, featuredPackages) {
            commit('SET_OFFER_FEATURED_PACKAGES', featuredPackages)
        },
        setOfferAddress({ commit }, payload) {
            const addressId = 0
            commit('RESET_CUSTOMER_ADDRESS', addressId)
            commit('SET_CUSTOMER_CURRENT_ADDRESS_ID', addressId)
            commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: 0, field: 'street', value: payload.deliveryStreet })
            commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressId, field: 'number', value: payload.deliveryNumber })
            commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressId, field: 'postcode', value: payload.deliveryPostcode })
            commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressId, field: 'city', value: payload.deliveryCity })
            commit('SET_CUSTOMER_ADDRESS_FIELD', { addressId: addressId, field: 'geometry', value: payload.geometry })
        },
        rejectOffer({ commit, getters }, payload) {
            return new Promise((resolve, reject) => {
                this.$api.post('b2b/v2/offers/reject', {
                    slug: payload.slug,
                    reason: payload.reason
                }).then(response => {
                    resolve()
                }).catch(error => {
                    console.error(error)
                })
            })
        },
        fetchOfferTerms({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/offers/terms').then(response => {
                    commit('SET_OFFER_TERMS', response.data.data)
                    resolve()
                })
            })
        },
        submitOffer({ commit }, payload) {
            commit('SET_ORDER_STATUS', 'sending')
            return new Promise((resolve, reject) => {
                this.$api.post('b2b/v2/offers/accept', payload).then(response => {
                    if(response.status === 200) {
                        router.push({ name: 'offer-thank-you-accept' }).catch(() => {})
                        resolve()
                    } else {
                        router.push({ name: 'offer-empty' }).catch(() => {})
                        reject(new Error('API Error: undefined response status'))
                    }
                }).catch(error => {
                    if(Object.prototype.hasOwnProperty.call(error.response.data, 'data')) {
                        reject(new Error(error.response.data.data.error))
                    }
                    if(Object.prototype.hasOwnProperty.call(error.response.data, 'message')) {
                        reject(new Error(error.response.data.message))
                    }
                    commit('SET_ORDER_STATUS', 'idle')
                })
            })
        }
    },
    getters: {
        offerSlug: (state) => {
            return state.slug
        },
        offerTerms: (state) => {
            return state.terms
        },
        offerAmountWeek: (state, getters) => (addressId) => {
            return getters.weekOrders.reduce((previous, current) => {
                if(current.addressId === addressId) {
                    previous = previous + parseFloat((current.net_price * current.amount).toFixed(2))
                }
                return parseFloat(previous)
            }, 0)
        },
        offerAmountMonth: (state, getters) => (addressId) => {
            return getters.weekOrders.reduce((previous, current) => {
                if(current.addressId === addressId) {
                    previous = previous + parseFloat((current.net_price * current.amount * current.period).toFixed(2))
                }
                return parseFloat(previous)
            }, 0)
        },
        offerTotalAmount: (state, getters) => {
            return getters.weekOrders.reduce((previous, current) => {
                previous = previous + parseFloat((current.net_price * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
        },
        offerTotalAmountMonth: (state, getters) => {
            return getters.weekOrders.reduce((previous, current) => {
                previous = previous + parseFloat((current.net_price * current.amount * current.period).toFixed(2))
                return parseFloat(previous)
            }, 0)
        },
        offerFeaturedPackages: (state, getters) => {
            return state.featuredPackages
        },
        offerStatus: (state) => {
            return state.status
        }
    }
}
